import Vpaid from "./vpaid";
import {CSSProperties, useEffect, useMemo, useState} from "react";
import {AdvertisementAction} from "../../state/types";
import {Summary} from "./maxSize";
import {useRefresh} from "../useRefresh";
import { Skippy } from "../skip";
import {PlayerElement} from "../PlayerElement";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../state";
import {VastType} from "./getSources";
import equals from "fast-deep-equal";
import Style from "../style.module.scss";

type Src = {
    src: string,
    width?: number,
    height?: number
};

export const useVpaid = (vast: VastType) => {

    const { volume, maxSize } = useSelector((state: AppState)=> ({volume: state.volume, maxSize: state.maxSize}), equals);
    const dispatch = useDispatch();
    const adv = useMemo(()=>{

        const isJs: Src = {
            src: '',
        };

        if (vast === 'NONE') {
            return isJs;
        }

        vast.sources.forEach(i=> {
            if (i.type === 'application/javascript')
            {
                isJs.src = i.src;
                isJs.width = i.width;
                isJs.height = i.height;
                if (isJs.width < 20 || isJs.height < 20) {
                    isJs.width = 0;
                    isJs.height = 0;
                }
                return true;
            }
            return false;
        });

        return isJs;
    }, [vast]);

    const hasAdv = !!adv.src && vast !=='NONE' ?  vast.id: 0;
    useRefresh(hasAdv);
    const [duration, setDuration] = useState(-1);
    const [start, setStart] = useState(false);
    const [adPlayFunc, setAddPlayFunc] = useState<undefined|(()=>void)>(undefined)
    useEffect(()=>{
        setDuration(-1);
        setStart(false);
        setAddPlayFunc(undefined);
        // eslint-disable-next-line
    }, [hasAdv])
    
    if (!hasAdv) {
        return false;
    }


    const { width, height, left, top } = Summary(start ? adv.width || 640 : 20, start ? adv.height || 640 : 20, maxSize, 23) || {
        width: 640,
        height: 640,
        left: 0,
        top: 0
    };

    const containerStyle: CSSProperties = {
        width: width + 'px',
        height: height + 'px',
        left: left + 'px',
        top:  top + 'px',
    }

    if (!start || width < 20 ) {
        containerStyle.backgroundColor = "transparent";
    }


    const useVpaidInner = () =>  (<div className={hasAdv ? Style.reklamaExternal: ''} style={{position: 'fixed'}}>
        {hasAdv && vast !== 'NONE' ?
        <Skippy adPlayFunc={adPlayFunc} top={top-23} time={duration} onClick={()=>{
            vast.tracker?.skip();
        }}/> : false}
        <div key={'container'} className={Style.reklamaContainer} style={containerStyle}>{[
            <PlayerElement key={'video'} width={20} height={20} style={{ position: 'absolute', left: '0px', top: '0px' }} sources={[]}/>,
            <Vpaid key={`vpaid`}
                   adLoad={()=>setStart(true)}
                   scriptUrl={adv.src}
                   className={''}
                   width={()=>width-20}
                   height={()=>height-20}
                   adPause={(f)=>{
                       setAddPlayFunc(() => f);
                   }}
                   adStart={(duration)=>{
                       setStart(true);
                       if (duration >0) {
                           setDuration(duration);

                       } // @ts-ignore (assetDuration)
                       else if (vast.tracker?.assetDuration > 0)
                       {
                           // @ts-ignore (assetDuration)
                           setDuration(vast.tracker?.assetDuration)
                       } else {
                           setDuration(0);
                       }
                       dispatch<AdvertisementAction>({
                           type: "AdvertisementPlay"
                       });
                   }}
                   volume={volume}
                   vast={vast}
                   complete={(hasError: string)=>{
                    if (hasError) {
                        dispatch<AdvertisementAction>({
                            type: "AdvertisementError",
                            payload: hasError
                        })
                    } else {
                        dispatch<AdvertisementAction>({
                            type: "AdvertisementEnd"
                        });
                    }
                   }}
            />]}
        </div>
    </div>);

    return useVpaidInner;
}